module.exports = __webpack_public_path__ + "img/肥料检测报告.4910b24b.png";